import ISettings from 'services/configurator/canvas/ISettings';

import { SET_SETTINGS } from './types';

export const setSettings = (
  settings: ISettings | null
): {
  type: string;
  settings: ISettings | null;
} => ({
  type: SET_SETTINGS,
  settings,
});
